import str from "../../../utils/strings"
import _moment from "moment"

export const moment = (val) => _moment(val).locale(str.locale)

export function convertLanguageCode(
  language: Language = "en",
  targetLanguageSystem: TargetLanguageSystem
): string {
  const map = {
    en: {
      sso: "en",
      old: "en",
      moment: "en"
    },
    "zh-Hant": {
      sso: "zh-tw",
      old: "tc",
      moment: "zh_TW"
    },
    "zh-Hans": {
      sso: "zh-cn",
      old: "sc",
      moment: "zh_CN"
    }
  }

  return map[language][targetLanguageSystem]
}

export function appendScript(
  targetElement: HTMLElement,
  async: boolean,
  src: string,
  id: string
) {
  const document = window.document
  if (document.querySelector(`#${id}`) == null) {
    let scriptTag = document.createElement("script")
    scriptTag.id = id
    scriptTag.async = async
    scriptTag.src = src
    targetElement.appendChild(scriptTag)
  }
}
